/**
 * get value of single query string parameter
 * @param {String} uri uri to parse
 * @param {String} key key to return value for
 * @returns {String|null} value
 */
export default function (uri, key) {
	const match = new RegExp('(?:^|[?&])' + key + '=(.*?)(?:&|$)', 'i').exec(uri);
	return match ? decodeURI(match[1]) : null;
}
